export enum EBookingStatus {
  Invalid,
  Created,
  Confirmed,
  Canceled,
  InProgress,
  Finished
}

export const EBookingStatusColor: any = {
  [EBookingStatus.Invalid]: 'red',
  [EBookingStatus.Created]: 'blue',
  [EBookingStatus.Confirmed]: 'blue',
  [EBookingStatus.InProgress]: 'blue',
  [EBookingStatus.Finished]: 'green',
  [EBookingStatus.Canceled]: 'red'
}
